export enum UserRoles {
  adminOwner = 'AdminOwner',
  customerSupport = 'CustomerSupport',
  techSupport = 'TechSupport',
}
